/**
 * Company: LifeAI, Copyright 2018, All Rights Reserved.
 * Author: Pavel Kostenko
 * Email: poul.kg@gmail.com
 * Date: 9/13/18
 * Time: 17:40
 */
import {Injectable} from '@angular/core';

@Injectable()
export class LaColorService {
  private _colors = {
    // seafoam
    'seafoam-1': '#23be9e',
    'seafoam-2': '#70ddc8',
    'seafoam-3': '#45ccb2',
    'seafoam-4': '#00b491',
    'seafoam-5': '#00846a',
    // Blue
    'blue-1': '#326cc2',
    'blue-2': '#7ba3df',
    'blue-3': '#5284cf',
    'blue-4': '#1054b8',
    'blue-5': '#0a3d89',
    // yellow
    'yellow-1': '#ffb22f',
    'yellow-2': '#ffd182',
    'yellow-3': '#ffc156',
    'yellow-4': '#ffa100',
    'yellow-5': '#cf8300',
    // red
    'red-1': '#f62d49',
    'red-2': '#fa8091',
    'red-3': '#f8546b',
    'red-4': '#f50022',
    'red-5': '#c5001b',
    // black
    'midnight-1': '#031422',
    'midnight-2': '#37434e',
    'midnight-3': '#767e86',
    'midnight-4': '#9ba1a7',
    'midnight-5': '#cdd0d3',
    'midnight-6': '#dadcde',
    'midnight-7': '#e6e7e8',
    'midnight-8': '#f2f3f4',
    'midnight-9': '#f7f8f8',
    // white
    'white': '#fff'
  };

  constructor() {
  }

  /**
   * Returns HEX or rgba color. ex.: #f62d49, rgba(3, 20, 34, 0.8)
   */
  getColorByName(name: string): string {
    if (this._colors[name] !== undefined) {
      return this._colors[name];
    } else {
      console.warn(`la-ngx-library do not have color: ${name}`);
      return 'red';
    }
  }

  getColorNames(): string[] {
    return Object.keys(this._colors);
  }

  /**
   * Need to convert hex to rba for secondary button
   */
  public hexToRgb(hex: string, alpha: any): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.length === 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16);
    const g = parseInt(hex.length === 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16);
    const b = parseInt(hex.length === 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16);
    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }

}
